<template>
  <article class="product-item relative flex c-flex-col c-flex-grow-1 overflow-hidden">
    <a
      v-if="banner.link"
      :href="banner.link"
      rel="noopener"
      class="w-100 h-100 block"
    >
      <img
        :src="banner.image_url"
        class="w-100 h-100 block"
        alt="Banner"
      >
    </a>
    <img
      v-else
      :src="banner.image_url"
      class="w-100 h-100 block"
      alt="Banner"
    >
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  data: { image_url: string; link?: string }[]
}>()


const banner = computed(() => props.data[Math.floor(Math.random() * props.data.length)])
</script>
